import { InputfieldTypes } from "../../../../../enums/InputFieldAttributesEnums";

export const WashedStatusOptions = ["Washed", "Unwashed", "Unknown"];
export const SupplyStatusOptions = [
  "High Supply",
  "Low Supply",
  "Average Supply",
  "No Supply",
  "Unknown Supply",
];
export const TestStatusOptions = [
  "Passes Spec",
  "Does Not Pass Spec",
  "Unknown",
];
export const TaxStatusOptions = ["Natural", "Manufactured", "Unknown"];

export const customStylingSelectField = {
  width: "100%",
  background: "#F1F5F9",
  borderColor: "#F1F5F9",
  textShadow: "none",
  color: "grey",
  display: "flex",
  justifyContent: "start",
};

export const PriceUnits = {
  LOAD_TXT: "Load",
  TON_TXT: "Ton",
};

export const selectWarnMessage = "Choose category and subcategory first";
export const submitErrorWarning = "All required fields must be filled";

export const getAddMaterialFields = ({
  selectPriceUnitAfter,
  handleMaterialModalOpen,
  categories,
  subCategories,
  materials,
}) => [
  {
    type: InputfieldTypes.SELECT,
    label: "Material Categories",
    name: "materialCategory",
    required: true,
    span: 12,
    options: categories,
    placeholder: "Select",
    showSearch: true,
  },
  {
    type: InputfieldTypes.SELECT,
    label: "Material Type",
    name: "materialType",
    required: true,
    span: 12,
    options: subCategories,
    placeholder: "Select",
    showSearch: true,
  },
  {
    type: InputfieldTypes.SELECT_CUSTOM_FIELD,
    label: "Material Name",
    name: "materialName",
    required: true,
    span: 12,
    options: materials,
    placeholder: "Select",
    handleOnSelect: () => {},
    customButtonLabel: "+ Add Material",
    handleModalOpen: handleMaterialModalOpen,
  },
  {
    type: InputfieldTypes.TEXT,
    label: "Price",
    name: "materialPrice",
    required: true,
    span: 12,
    placeholder: "Price",
    addOnAfter: selectPriceUnitAfter,
  },
  {
    type: InputfieldTypes.SELECT,
    label: "Testing Status",
    name: "testingStatus",
    required: false,
    span: 12,
    options: TestStatusOptions?.map((item) => ({ value: item, lable: item })),
    placeholder: "Select",
  },
  {
    type: InputfieldTypes.SELECT,
    label: "Washed Status",
    name: "washedStatus",
    required: false,
    span: 12,
    options: WashedStatusOptions?.map((item) => ({ value: item, lable: item })),
    placeholder: "Select",
  },
  {
    type: InputfieldTypes.SELECT,
    label: "Material Tax",
    name: "materialTax",
    required: true,
    span: 12,
    options: TaxStatusOptions?.map((item) => ({ value: item, lable: item })),
    placeholder: "Select",
  },
  {
    type: InputfieldTypes.SELECT,
    label: "Supply",
    name: "supplyStatus",
    required: false,
    span: 12,
    options: SupplyStatusOptions?.map((item) => ({ value: item, lable: item })),
    placeholder: "Select",
  },
  {
    type: InputfieldTypes.TEXT_AREA,
    label: "Material Description",
    name: "materialDescription",
    required: false,
    span: 24,
    placeholder: "Enter notes",
    maxLength: 500,
    noResize: true,
  },
];

export const affectedJobConstants = {
  MODAL_TITLE: "Pricing Update Confirmation",
  MODAL_CONTENT_BEFORE_COUNT: "Changing this rate will impact",
  MODAL_CONTENT_AFTER_COUNT: "active jobs. Please immediately inform the sales team.",
}